import React from 'react';
import styled from 'styled-components';
/**
 * * input page에서 flex로 보여지게 하는 박스
 */

interface IProps {
  children: JSX.Element | JSX.Element[];
  style?: React.CSSProperties;
}
const InputFlexBox = ({ children, style }: IProps) => {
  return <Container style={style}>{children}</Container>;
};

export default InputFlexBox;
const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
